import React from "react";

const Disclaimer = () => {
  return (
    <div style={{ padding: "40px", paddingTop: "120px", maxWidth: "900px", margin: "0 auto", fontFamily: "DM Sans, sans-serif", lineHeight: "1.7", color: "#333" }}>
      <h1>Disclaimer</h1>
      <p>Last updated: October 2025</p>

      <h2>1. General Information</h2>
      <p>All content provided on HelloParyatak is for informational purposes only. We make reasonable efforts to ensure accuracy but do not guarantee completeness or reliability.</p>

      <h2>2. Travel Risks</h2>
      <p>Travel involves inherent risks, including but not limited to accidents, delays, weather changes, or political situations. Users are responsible for understanding these risks.</p>

      <h2>3. Third-Party Links</h2>
      <p>Our website may contain links to third-party websites. We are not responsible for their content, privacy policies, or practices.</p>

      <h2>4. No Professional Advice</h2>
      <p>Information on HelloParyatak does not constitute legal, medical, or financial advice. Users should consult appropriate professionals when needed.</p>

      <h2>5. Limitation of Liability</h2>
      <p>HelloParyatak will not be liable for any direct, indirect, incidental, or consequential damages resulting from the use of our website or services.</p>

      <h2>6. Changes to Disclaimer</h2>
      <p>We may update this Disclaimer periodically. Users are encouraged to review it regularly for any changes.</p>

      <h2>Contact</h2>
      <p>For any questions regarding this Disclaimer, contact us at <a href="mailto:info@helloparyatak.com">info@helloparyatak.com</a>.</p>
    </div>
  );
};

export default Disclaimer;
